var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { View } from 'react-native';
import { SkeletonLoaderComponent } from './SkeletonLoaderComponent';
export var ModalSkeleton = props => {
  var style = props.style,
    restProps = __rest(props, ["style"]);
  return _jsxs(View, Object.assign({
    style: style
  }, {
    children: [_jsx(SkeletonLoaderComponent, Object.assign({
      type: "title",
      fullWidth: true
    }, restProps)), _jsx(SkeletonLoaderComponent, Object.assign({
      type: "square-card",
      style: {
        marginTop: 20,
        justifyContent: 'center'
      }
    }, restProps)), _jsx(SkeletonLoaderComponent, Object.assign({
      type: "title",
      fullWidth: true,
      style: {
        marginTop: 20
      }
    }, restProps)), _jsx(SkeletonLoaderComponent, Object.assign({
      type: "title",
      width: '76%',
      style: {
        marginTop: 8,
        justifyContent: 'center'
      }
    }, restProps)), _jsx(SkeletonLoaderComponent, Object.assign({
      type: "list-item-small",
      style: {
        marginTop: 55
      },
      fullWidth: true
    }, restProps))]
  }));
};